import DateTime from "../../lib/dateTime.js";

export function listInventoryHistoryYears()
{
	let delta = DateTime.today.year - 2025;
	let years = [...[...Array(delta + 1)].keys()].map(k => '' + (2025 + k));
	years.sort((a, b) => b.localeCompare(a))
	return years;
}

export function validateMotorInventoryType(type)
{
	if(type == 'stock')
		return type;

	let years = listInventoryHistoryYears();

	if(years.find(y => y == type))
		return type;

	return null;
}